import { render, staticRenderFns } from "./amendments-page.vue?vue&type=template&id=4eaa347a"
import script from "./amendments-page.vue?vue&type=script&lang=js"
export * from "./amendments-page.vue?vue&type=script&lang=js"
import style0 from "./amendments-page.vue?vue&type=style&index=0&id=4eaa347a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports